<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-persona-list" class="ag-grid-container">
      <div class="vx-card">
        <grid-panel
            height="xl"
            :column-defs="columnDefs"
            :url="() => this.personaList"
            :auto-size="true"
            @rowClicked="view"
            class="personas-grid"
            @update:deleted="getPersonas"
            title="Personas"
        >
          <vs-dropdown-item>
            <span
                class="flex items-center"
                @click="$router.push({ name: 'personas.data-centre.create' })"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
              <span>Create Persona</span>
            </span>
          </vs-dropdown-item>

        </grid-panel>
      </div>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import ButtonToggle from "../../../components/extra-components/toggle/ButtonToggle";
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import CellRendererVerified from "../../../components/ag-grid/cell-renderer/CellRendererVerified";

export default {
  components: {
    TGrid,
    GridPanel,
    YesNoToggle,
    ButtonToggle,
    StatisticsCardLine,
    CellRendererVerified
  },
  mixins: [CellMatchingMixin],
  data () {
    return {
      toggle: [
        {
          text: 'None',
          value: 0,
        },
        {
          text: 'By Section',
          value: 1,
        }
      ],
      toggleValue: 0,
      personaList: [],
      searchQuery: '',
      showDeleted: false,
      personasBySectionGridOptions: {
        groupUseEntireRow: true,
        groupMultiAutoColumn: true,
        groupRowRendererParams: {
          suppressCount: false
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Persona Name',
          field: 'PersonaName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'Role Name',
          field: 'role.RoleName',
          filter: 'agTextColumnFilter',
          width: 350,
        },
        {
          headerName: 'System',
          field: 'System',
          cellRenderer: 'CellRendererVerified',
          width: 350,
        },
      ],
      autoGroupColumnDef: {
        minWidth: 200,
      },
    }
  },
  created() {
    this.getPersonas();
  },
  methods: {
    getPersonas() {
      this.personaList = this.$api.dataCentrePersonas.list();

      return this.personaList;
    },
    view({data}) {
      if (!data) {
        return;
      }

      this.$router.push({ name: 'personas.data-centre.edit', params: { id: data.id }}).catch(() => {});
    }
  },

}

</script>

<style lang="scss">
</style>
